import React, { useMemo } from 'react';
import { Affix, Card, Tabs } from 'antd';
import { IntroTab } from './intro-tab';
import { BanOnListTab } from './ban-on-list-tab';
import { BanOffListTab } from './ban-off-list-tab';
import { ScheduleTab } from './schedule-tab';
import { LogsTab } from './logs-tab';
import { PendingTab } from './pending-tab';
import './index.less';

const { TabPane } = Tabs;

const TAB_KEYS = ['intro', 'list', 'unlist', 'schedule', 'logs', 'pending'] as const;

const getTabFromUrl = () => {
    const hash = window.location.hash || '';
    const hashQuery = hash.includes('?') ? hash.split('?')[1] : '';
    const params = new URLSearchParams(window.location.search || hashQuery);
    const tab = params.get('tab') || '';
    return TAB_KEYS.includes(tab as typeof TAB_KEYS[number]) ? tab : 'intro';
};

const renderTabBar = (props: any, DefaultTabBar: React.ComponentClass<any>) => (
    <Affix offsetTop={0}>
        <div className="shelf-rule__tabs-affix">
            <DefaultTabBar {...props} />
        </div>
    </Affix>
);

const ShelfRuleListView = () => {
    const defaultActiveKey = useMemo(() => getTabFromUrl(), []);

    return (
        <div className="shelf-rule">
            <Card>
                <Tabs
                    defaultActiveKey={defaultActiveKey}
                    className="shelf-rule__tabs"
                    animated={{ inkBar: true, tabPane: false }}
                    renderTabBar={renderTabBar}
                >
                    <TabPane tab="规则说明" key="intro">
                        <IntroTab />
                    </TabPane>
                    <TabPane tab="禁止上架名单" key="list">
                        <BanOnListTab />
                    </TabPane>
                    <TabPane tab="禁止下架名单" key="unlist">
                        <BanOffListTab />
                    </TabPane>
                    <TabPane tab="定时上下架" key="schedule">
                        <ScheduleTab />
                    </TabPane>
                    <TabPane tab="执行日志" key="logs">
                        <LogsTab />
                    </TabPane>
                    <TabPane tab="待下架" key="pending">
                        <PendingTab />
                    </TabPane>
                </Tabs>
            </Card>
        </div>
    );
};

export const shelfRuleListView = ShelfRuleListView;
